import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=bd24ccb8&scoped=true"
import script from "./DefaultView.vue?vue&type=script&lang=js"
export * from "./DefaultView.vue?vue&type=script&lang=js"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=bd24ccb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd24ccb8",
  null
  
)

export default component.exports